import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Container } from '@material-ui/core';
import Page from 'src/components/Page';
import Header from 'src/components/Header';
import Todos from './Todos';


const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  todos: {
    marginTop: theme.spacing(1)
  }
}));

function UyariMerkezi() {
  const classes = useStyles();
  return (
    <Page className={classes.root} title="Malzeme İhtiyaçları">
      <Container maxWidth="lg">
        <Header />        
        <Todos className={classes.todos} />       
      </Container>
    </Page>
  );
}

export default UyariMerkezi;
